module.exports = __webpack_public_path__ + "img/energetika_logo.00af5a43.png";